import { render, staticRenderFns } from "./MyClientCard.vue?vue&type=template&id=49af997c&"
import script from "./MyClientCard.vue?vue&type=script&lang=js&"
export * from "./MyClientCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports